export const copy = {
  title: 'You do not need to complete this form.',
  message:
    'You indicated they are not of Māori descent. If this was selected in error, please return to the previous question to update your response.',
};
